import React from 'react';
import {Form} from 'forms';
import {FormNameEnum} from 'filters-selections';

export const ItemAnswerOpenEnded = () => {
  return <Form.TextArea name={FormNameEnum.openEndedQuestion} placeholder={''} disabled />;
};
